import React, { useEffect } from "react";

export const Layout = ({ children, ...rest }) => {
  return (
    <div style={{ minHeight: "100vh" }}>
      <div>{children}</div>
    </div>
  );
};
